import React, { createRef, useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { ComparisonGraph } from "./comparisonGraph.jsx";
import DownloadIcon from "../trendPage/commonComponent/downloadIcon.jsx";
import { Screenshot } from "../trendPage/commonComponent/screenshot.jsx";
import { TabSelector } from "../tabSelector/tabSelector.jsx";
import localizationKeys from "../../i18n/localizationKeys";
import { useParams } from "react-router-dom";
import { DATE_FORMAT } from "../../constants/constants.js";
import dayjs from "util/dayjs-init.js";
import { NAVIGATION_BAR_HEIGHT } from "../../constants/layout.js";


const VESSEL_SELECTOR_HEIGHT = `calc(100dvh - ${NAVIGATION_BAR_HEIGHT}px - 10px - 65px)`;

const downloadIconStyle = 
{    
  width: "25px",
  height: "25px",
  padding: "0px 0px",
  minWidth: "0px",
  marginRight: "10px",
}
  

const NUMBER_OF_COMPARISON_GRAPH = 4;
const commonTabs = (t) => [
  {
    name: t(localizationKeys.DataComparison_lower),
    id: "dataComparison",
  },
];

export const Comparison = () => {
  const {vesselId} = useParams();
  const { t } = useTranslation();
  const [firstGraphStartDate, setFirstGraphStartDate] = useState(dayjs.utc().subtract(7, "d").startOf("minute").format(DATE_FORMAT));
  const [firstGraphEndDate, setFirstGraphEndDate] = useState(dayjs.utc().startOf("minute").format(DATE_FORMAT));
  const [secondGraphStartDate, setSecondGraphStartDate] = useState("");
  const [secondGraphEndDate, setSecondGraphEndDate] = useState("");
  const [thirdGraphStartDate, setThirdGraphStartDate] = useState("");
  const [thirdGraphEndDate, setThirdGraphEndDate] = useState("");
  const [fourthGraphStartDate, setFourthGraphStartDate] = useState("");
  const [fourthGraphEndDate, setFourthGraphEndDate] = useState("");
  const startDateArray = [firstGraphStartDate, secondGraphStartDate, thirdGraphStartDate, fourthGraphStartDate];
  const startDateSetterArray = [setFirstGraphStartDate, setSecondGraphStartDate, setThirdGraphStartDate, setFourthGraphStartDate];
  const endDateArray = [firstGraphEndDate, secondGraphEndDate, thirdGraphEndDate, fourthGraphEndDate];
  const endDateSetterArray = [setFirstGraphEndDate, setSecondGraphEndDate, setThirdGraphEndDate, setFourthGraphEndDate];
  const [isGraphDateTimeSync, setIsGraphDateTimeSync] = useState(true);
  const [changeBySync, setChangeBySync] = useState(true);
  const [vessels, setVessels] = useState(Array(NUMBER_OF_COMPARISON_GRAPH).fill({}));
  const [typeForComparison, setTypeForComparison] = useState(Array(NUMBER_OF_COMPARISON_GRAPH));
  const [selectedGraphTypeForComparison, setSelectedGraphTypeForComparison] = useState(
    Array(NUMBER_OF_COMPARISON_GRAPH)
  );
  const [selectedGraphForComparison, setSelectedGraphForComparison] = useState(
    Array(NUMBER_OF_COMPARISON_GRAPH)
  );
  const [graphDataForComparison, setGraphDataForComparison] = useState(
    Array(NUMBER_OF_COMPARISON_GRAPH)
  );
  const [isLoadingForComparison, setIsLoadingForComparison] = useState(
    Array(NUMBER_OF_COMPARISON_GRAPH).fill(false)
  );
  const screenshotRef = useRef();
  const refs = useRef([]);
  for (let i = 0; i < NUMBER_OF_COMPARISON_GRAPH; i++) {
    refs.current[i] = createRef();
  }

  const wait = (msec) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, msec);
    });
  };

  const downloadTwoCsvOnClick = async () => {
    for (const value of refs.current) {
      if (!value.current) return;
      value.current.click();
      //avoid safari issue
      await wait(100);
    }
  };

  // sync first graph and other graphs duration until other ones are changed by user.
  useEffect(() => {
    if(isGraphDateTimeSync) {
      setSecondGraphStartDate(firstGraphStartDate);
      setThirdGraphStartDate(firstGraphStartDate);
      setFourthGraphStartDate(firstGraphStartDate);
      setChangeBySync(true);
    }
  }, [firstGraphStartDate]);
  
  useEffect(() => {
    if(secondGraphStartDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [secondGraphStartDate])

    useEffect(() => {
    if(thirdGraphStartDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [thirdGraphStartDate])

  useEffect(() => {
    if(fourthGraphStartDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [fourthGraphStartDate])

    useEffect(() => {
    if(secondGraphStartDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [secondGraphStartDate])

  useEffect(() => {
    if(isGraphDateTimeSync) {
      setSecondGraphEndDate(firstGraphEndDate);
      setThirdGraphEndDate(firstGraphEndDate);
      setFourthGraphEndDate(firstGraphEndDate);
      setChangeBySync(true);
    }
  }, [firstGraphEndDate]);


  useEffect(() => {
    if(secondGraphEndDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [secondGraphEndDate])

  useEffect(() => {
    if(thirdGraphEndDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [thirdGraphEndDate])

  useEffect(() => {
    if(fourthGraphEndDate === "") return; // skip first init
    if(changeBySync) {
      setChangeBySync(false);
    }else{
      setIsGraphDateTimeSync(false);
    }
  }, [fourthGraphEndDate])

  return (
    <>
      <TabSelector tabs={commonTabs(t)} selectedOne={"dataComparison"} clickHandler={() => {}}>
        <Grid container>
          <Grid item size={{ xs:9 }} sx={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: '24px'}}>
            <Button sx={downloadIconStyle} onClick={() => downloadTwoCsvOnClick()}>
              <DownloadIcon color={"#FFFFFF"} />
            </Button>
            <Screenshot element={screenshotRef.current} isTwoGraph={true} />
          </Grid>
        </Grid>
      </TabSelector>

      <Grid container spacing={2} ref={screenshotRef}>
        {[...Array(NUMBER_OF_COMPARISON_GRAPH)].map((_, i) => (
          <ComparisonGraph
            graphRef={refs.current[i]}
            number={i}
            vessels={vessels}
            setVessels={setVessels}
            startDate={startDateArray[i]}
            setStartDate={startDateSetterArray[i]}
            endDate={endDateArray[i]}
            setEndDate={endDateSetterArray[i]}
            initialVesselId={vesselId}
            height={VESSEL_SELECTOR_HEIGHT}
            key={`comparison-chart-key-${i}`}
            typeForComparison={typeForComparison}
            selectedGraphTypeForComparison={selectedGraphTypeForComparison}
            selectedGraphForComparison={selectedGraphForComparison}
            graphDataForComparison={graphDataForComparison}
            isLoadingForComparison={isLoadingForComparison}
            setTypeForComparison={setTypeForComparison}
            setSelectedGraphTypeForComparison={setSelectedGraphTypeForComparison}
            setSelectedGraphForComparison={setSelectedGraphForComparison}
            setGraphDataForComparison={setGraphDataForComparison}
            setIsLoadingForComparison={setIsLoadingForComparison}
          />
        ))}
      </Grid>
    </>
  );
};